const urls = {
	upload: {
		fileUpload: "/file_upload",
		uploadFile: "https://files.medflying.com/file_system/files",
		uploadAccept: "https://files.medflying.com/file_system/upload_accept",
		uploadComplete: "https://files.medflying.com/file_system/upload_complete",
		uploadFileTransfer: "https://files.medflying.com/file_system/files_transfer",
		uploadBase64: "/api/uploadbase64",
		check_files: "/project/check_files"//检查文件是否重复
	},
	user: {
		login: "/api/login",
		code:"/api/sendsms"
	},
	accountList: {
		list: "/file_list",
		create: "/user_info",
		update: "/user_info",
		delete: "/user_info",
	},
	index:{
		get_category_list:"/category/list/wcount",
		get_category_info:"/category/info",
		get_project_list:"/project/list/wcount",
		get_project_list_company:"/project/list/for/company",
	},
}
export default urls;